/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Enum, EnumSet } from '@gh/core-data';
import { curryRight, identity, isNil } from 'lodash';
import { EnumDictionary, TextDictionary } from './dictionary';
import {
  DictionaryDefinition,
  DictionaryDefinitionPredicate,
  DictionaryParams,
  DictionaryService,
} from './dictionary.service';

const NUM_OF_PREDICATE_ARGUMENTS = 2;

export function createEnumDictionary<T extends Enum<S>, S>(
  enumeration: Enum<T>,
  predicate?: DictionaryDefinitionPredicate<EnumSet<T>>,
): DictionaryDefinition<EnumDictionary<EnumSet<T>>> {
  const get = (service: DictionaryService) => service.getByEnum(enumeration);
  const filter = isNil(predicate)
    ? identity
    : (dictionary: EnumDictionary<EnumSet<T>>, params: DictionaryParams) =>
        dictionary.filter(
          <any>curryRight(predicate, NUM_OF_PREDICATE_ARGUMENTS)(<any>params),
        );

  return { get, filter };
}

export function createTextDictionary(
  name: string,
  predicate?: DictionaryDefinitionPredicate<string>,
): DictionaryDefinition<TextDictionary> {
  const get = (service: DictionaryService) => service.get(name);
  const filter = isNil(predicate)
    ? identity
    : (dictionary: TextDictionary, params: DictionaryParams) =>
        dictionary.filter(
          <any>curryRight(predicate, NUM_OF_PREDICATE_ARGUMENTS)(<any>params),
        );

  return { get, filter };
}
